import { render, staticRenderFns } from "./PopupConfirmCopy.vue?vue&type=template&id=38e235cb&"
import script from "./PopupConfirmCopy.vue?vue&type=script&lang=ts&"
export * from "./PopupConfirmCopy.vue?vue&type=script&lang=ts&"
import style0 from "./PopupConfirmCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports